'use client'

import { ComponentProps } from 'react'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import HeroMessage from './HeroMessage'

type Props = Pick<ComponentProps<typeof HeroMessage>, 'toggleSidebar' | 'children'>

const HeroMessageWithConversationContext = (props: Props) => {
  const { conversation, transaction } = useConversationContext()

  if (!conversation?.item || !transaction) return null

  return (
    <HeroMessage
      conversationId={String(conversation.id)}
      isSellerBusiness={Boolean(transaction.seller?.business)}
      itemCount={transaction.itemsCount}
      itemId={conversation.item.id}
      itemTitle={conversation.item.title}
      itemUrl={conversation.item.url}
      oppositeUserId={conversation.oppositeUser?.id}
      photo={conversation.item.photo ?? undefined}
      price={transaction.offer.price}
      sellerId={transaction.seller?.id}
      serviceFee={transaction.serviceFee}
      shipmentStatus={transaction.shipment?.status ?? undefined}
      totalAmountWithoutTax={transaction.totalAmountWithoutTax}
      transactionId={transaction.id}
      transactionStatus={transaction.status ?? undefined}
      userSide={transaction.userSide}
      {...props}
    />
  )
}

export default HeroMessageWithConversationContext
